import type { AuthAction, State } from "./types";
import { RegisterPageRoute } from "@/routes/auth";

export const initialState: State = {
  mode: window.location.pathname === RegisterPageRoute ? "register" : "login",
  shouldSubmit: false,
  values: { email: "", password: "", passwordConfirm: "" },
  errors: {},
  isRegisteredUser: false,
};

export const reducer = (state: State, action: AuthAction): State => {
  switch (action.type) {
    case "SET_MODE":
      return {
        ...state,
        mode: action.payload,
      };
    case "SET_IS_REGISTERED_USER":
      return {
        ...state,
        isRegisteredUser: action.payload,
      };
    case "CHANGE_SHOULD_SUBMIT":
      return {
        ...state,
        shouldSubmit: action.payload,
      };
    case "CHANGE_VALUES":
      return {
        ...state,
        values: {
          ...state.values,
          ...action.payload,
        },
      };
    case "CHANGE_ERRORS":
      return {
        ...state,
        errors: {
          ...state.errors,
          ...action.payload,
        },
      };
    default:
      throw new Error();
  }
};
